'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef, Children } from 'react';

/**
 * Use `AvatarStack` to constrain Avatars into a stack.
 *
 * @example
 * <EXPERIMENTAL_AvatarStack>
 *   <Avatar aria-label='name'>
 *     <img src={cat1} alt='' />
 *   </Avatar>
 *   <Avatar aria-label='name'>
 *     <BriefcaseIcon />
 *   </Avatar>
 *   <Avatar aria-label='name' initials='sm' />
 * </EXPERIMENTAL_AvatarStack>
 */
const EXPERIMENTAL_AvatarStack = forwardRef(function AvatarStack({ className, gap, suffix, avatarSize, overlap, expandable, children, ...rest }, ref) {
    const style = {
        ...(rest.style || {}),
        '--dsc-avatar-stack-gap': gap !== undefined ? `${gap}` : undefined,
        '--dsc-avatar-stack-size': avatarSize ? `${avatarSize}` : undefined,
        '--dsc-avatar-stack-overlap': overlap !== undefined ? `${overlap}` : undefined,
        '--dsc-avatar-count': expandable === 'fixed' ? Children.count(children) : undefined,
    };
    return (jsx("span", { tabIndex: rest.tabIndex !== undefined ? rest.tabIndex : expandable ? 0 : undefined, ref: ref, className: cl(`ds-avatar-stack`, className), style: style, "data-expandable": expandable, "data-suffix": suffix, ...rest, children: children }));
});

export { EXPERIMENTAL_AvatarStack };
